import VoltarAoPainelOwner from "@/components/VoltarAoPainelOwner";
import DefinirSenha from "@/pages/DefinirSenha";
import CommercialNewContract from "@/pages/CommercialNewContract";
import CommercialCommissionSettings from "@/pages/CommercialCommissionSettings";
import CommercialIntegrations from "@/pages/CommercialIntegrations";
import ComprovantesPage from "./pages/comprovantes/ComprovantesPage";
import ComprovantesFiltroPage from "./pages/comprovantes/ComprovantesFiltroPage";
import { lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate} from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider } from "@/contexts/ThemeContext";
import {
  AuthProvider,
  useAuth,
} from "@/contexts/AuthContext";
import { PermissionsProvider } from "@/contexts/PermissionsContext";
import AreaCliente from "@/pages/AreaCliente";
import AreaClienteEscritorio from "@/pages/AreaClienteEscritorio";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { RequirePermission } from "@/components/RequirePermission";
import { AppLayout } from "@/components/AppLayout";
import { HomeRedirect } from "@/components/HomeRedirect";
import ActivityTracker from "@/components/ActivityTracker"; // PP9

import Atendimento from "@/pages/Atendimento";
import ExclusaoSimplesPage from "./pages/ExclusaoSimplesPage";
import EProcessosPage from "./pages/EProcessosPage"; // EPROCESSOS_V1
const Landing = lazy(() => import("@/pages/Landing"));
const Login = lazy(() => import("@/pages/Login"));
const Register = lazy(() => import("@/pages/Register"));
const AcceptInvite = lazy(() => import("@/pages/AcceptInvite"));
const CommercialActivation = lazy(() => import("@/pages/CommercialActivation"));
const EquipeLogin = lazy(() => import("@/pages/EquipeLogin"));
const CommercialPortalHome = lazy(() => import("@/pages/CommercialPortalHome"));
const Dashboard = lazy(() => import("@/pages/Dashboard"));
const DashboardFederal = lazy(() => import("@/pages/DashboardFederal"));
const Hub = lazy(() => import("@/pages/Hub"));
const PrimeirosPassos = lazy(() => import("@/pages/PrimeirosPassos")); // PP4
const Intensivao = lazy(() => import("@/pages/Intensivao")); // PP14
const PlataformaAtivacao = lazy(() => import("@/pages/PlataformaAtivacao")); // PP10
const Empresas = lazy(() => import("@/pages/Empresas"));
const GerenciarEmpresas = lazy(() => import("@/pages/GerenciarEmpresas"));
const EmpresaDetalhe = lazy(() => import("@/pages/EmpresaDetalhe"));
const EmpresasImport = lazy(() => import("@/pages/EmpresasImport"));
const IntegrationEngine = lazy(() => import("@/pages/IntegrationEngine"));
const SerproCaixaPostal = lazy(() => import("@/pages/SerproCaixaPostal"));
const SerproSitfis = lazy(() => import("@/pages/SerproSitfis"));
const SerproScheduler = lazy(() => import("@/pages/SerproScheduler"));
const Alertas = lazy(() => import("@/pages/Alertas"));
const Mensagens = lazy(() => import("@/pages/Mensagens"));
const Prioridades = lazy(() => import("@/pages/Prioridades"));
const Timeline = lazy(() => import("@/pages/Timeline"));
const Usuarios = lazy(() => import("@/pages/Usuarios"));
const PerfisPermissoes = lazy(() => import("@/pages/PerfisPermissoes"));
const Auditoria = lazy(() => import("@/pages/Auditoria"));
const IA = lazy(() => import("@/pages/IA"));
const Automacoes = lazy(() => import("@/pages/Automacoes"));
const ApiKeys = lazy(() => import("@/pages/ApiKeys"));
const Configuracoes = lazy(() => import("@/pages/Configuracoes"));
const MeuPlano = lazy(() => import("@/pages/MeuPlano"));
const PlataformaAtendimento = lazy(() => import("@/pages/PlataformaAtendimento"));
const Certidoes = lazy(() => import("@/pages/Certidoes"));
const Debitos = lazy(() => import("@/pages/Debitos"));
const Parcelamentos = lazy(() => import("@/pages/Parcelamentos"));
const ParcelamentoDetalhe = lazy(() => import("@/pages/ParcelamentoDetalhe"));
const Obrigacoes = lazy(() => import("@/pages/Obrigacoes"));
const DCTFWeb = lazy(() => import("@/pages/DCTFWeb"));
const DividaAtiva = lazy(() => import("@/pages/DividaAtiva"));
const PGDAS = lazy(() => import("@/pages/PGDAS"));
const MIT = lazy(() => import("@/pages/MIT"));
const MitDetalhe = lazy(() => import("@/pages/MitDetalhe"));
const SimplesNacional = lazy(() => import("@/pages/SimplesNacional"));
const SimplesNacionalApuracao = lazy(() => import("@/pages/SimplesNacionalApuracao"));
const FactorR = lazy(() => import("@/pages/FactorR"));
const Defis = lazy(() => import("@/pages/Defis"));
const Agenda = lazy(() => import("@/pages/Agenda"));
const DiagnosticoGeral = lazy(() => import("@/pages/DiagnosticoGeral"));
const Painel360 = lazy(() => import("@/pages/Painel360"));
const SimplerBI = lazy(() => import("@/pages/SimplerBI"));
const HealthScore = lazy(() => import("@/pages/HealthScore"));
const Sisi = lazy(() => import("@/pages/Sisi"));
const Relatorios = lazy(() => import("@/pages/Relatorios"));
const GestaoDAS = lazy(() => import("@/pages/GestaoDAS"));
const PlataformaSaude = lazy(() => import("@/pages/PlataformaSaude"));
const PlataformaTenants = lazy(() => import("@/pages/PlataformaTenants"));
const PlataformaInicio = lazy(() => import("@/pages/PlataformaInicio"));
const PlataformaFinanceiro = lazy(() => import("@/pages/PlataformaFinanceiro"));
const PlataformaResultados = lazy(() => import("@/pages/PlataformaResultados"));
const PlataformaSerpro = lazy(() => import("@/pages/PlataformaSerpro"));
const PlataformaSerproUsage = lazy(() => import("@/pages/PlataformaSerproUsage"));
const Procuradores = lazy(() => import("@/pages/Procuradores"));
const ProcuradorVincularEmpresas = lazy(() => import("@/pages/ProcuradorVincularEmpresas"));
const DemoTour = lazy(() => import("@/pages/DemoTour"));
const ComingSoon = lazy(() => import("@/pages/ComingSoon"));
const NotFound = lazy(() => import("@/pages/NotFound"));
const Clientes = lazy(() => import("./pages/Clientes"));
function RequirePlatformOwner({ children }) {
  const { user } = useAuth();

  if (user?.role !== "platform_owner") {
    return <Navigate to="/app" replace />;
  }

  return children;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <PermissionsProvider>
          <BrowserRouter>
            <Suspense
              fallback={
                <div
                  className="min-h-screen bg-background"
                  aria-label="Carregando"
                />
              }
            >
              <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/cliente/:slug" element={<AreaCliente />} />
              <Route path="/demo-tour" element={<DemoTour />} />
              <Route path="/login" element={<Login />} />
              <Route path="/equipe" element={<EquipeLogin />} />
              <Route
                path="/portal/:portalSlug"
                element={<Login />}
              />
              <Route path="/register" element={<Register />} />
              <Route path="/accept-invite" element={<AcceptInvite />} />
              <Route path="/definir-senha" element={<DefinirSenha />} />
<Route path="/commercial-activate" element={<CommercialActivation />} />
              <Route path="/commercial-portal/novo-contrato" element={<><CommercialNewContract /><VoltarAoPainelOwner /></>} />
              <Route path="/commercial-portal/comissoes-config" element={<><CommercialCommissionSettings /><VoltarAoPainelOwner /></>} />
              <Route path="/commercial-portal/integracoes" element={<><CommercialIntegrations /><VoltarAoPainelOwner /></>} />
              <Route path="/commercial-portal" element={<><CommercialPortalHome /><VoltarAoPainelOwner /></>} />

              <Route
                path="/app"
                element={
                  <ProtectedRoute>
                    <ActivityTracker />
                    <AppLayout />
                  </ProtectedRoute>
                }
              >
                {/* Módulos em produção */}
                <Route index element={<HomeRedirect />} />
                <Route path="hub" element={<Hub />} />
                <Route path="area-do-cliente" element={<AreaClienteEscritorio />} />
                <Route path="primeiros-passos" element={<PrimeirosPassos />} /> {/* PP4 */}
                <Route path="intensivao" element={<Intensivao />} /> {/* PP14 */}
                <Route path="jornada-simpler" element={<Navigate to="/app/intensivao" replace />} /> {/* PP14 */}
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="dashboard-federal" element={<DashboardFederal />} />
                <Route path="dashboard-federal/pgdas" element={<PGDAS />} />
<Route path="dashboard-federal/comprovantes" element={<ComprovantesPage />} />
<Route path="/app/dashboard-federal/exclusao" element={<ExclusaoSimplesPage />} />
<Route path="/app/dashboard-federal/eprocessos" element={<EProcessosPage />} />
<Route path="dashboard-federal/comprovantes/filtro" element={<ComprovantesFiltroPage />} />
                <Route path="dashboard-federal/mit" element={<MIT />} />
                <Route path="dashboard-federal/mit/:cnpj/:idApuracao" element={<MitDetalhe />} />
                <Route
                  path="dashboard-federal/divida-ativa"
                  element={<DividaAtiva />}
                />

                {/* Compatibilidade com links antigos */}
                <Route
                  path="divida-ativa"
                  element={<Navigate to="/app/dashboard-federal/divida-ativa" replace />}
                />
                <Route
                  path="pgfn"
                  element={<Navigate to="/app/dashboard-federal/divida-ativa" replace />}
                />
                <Route
                  path="debitos"
                  element={<Navigate to="/app/dashboard-federal/divida-ativa" replace />}
                />
                <Route path="empresas" element={<Empresas />} />
                <Route
                  path="gerenciar-empresas"
                  element={<GerenciarEmpresas />}
                />
                <Route path="empresas/importar" element={<EmpresasImport />} />
                <Route path="empresas/:id" element={<EmpresaDetalhe />} />
                <Route
                  path="integracoes"
                  element={
                    <RequirePlatformOwner>
                      <IntegrationEngine />
                    </RequirePlatformOwner>
                  }
                />
                <Route
                  path="integracoes/scheduler"
                  element={
                    <RequirePlatformOwner>
                      <SerproScheduler />
                    </RequirePlatformOwner>
                  }
                />
                <Route path="serpro/caixa-postal" element={<SerproCaixaPostal />} />
                <Route path="serpro/sitfis" element={<RequirePermission permission="situacao_fiscal.view"><SerproSitfis /></RequirePermission>} />
                <Route path="alertas" element={<Alertas />} />
                <Route path="mensagens" element={<Mensagens />} />
                <Route path="prioridades" element={<Prioridades />} />
                <Route path="timeline" element={<Timeline />} />
                <Route path="usuarios" element={<RequirePermission permission="usuarios.view"><Usuarios /></RequirePermission>} />
                <Route path="procuradores" element={<RequirePermission permission="empresas.view"><Procuradores /></RequirePermission>} />
                <Route path="procuradores/:id/vincular-empresas" element={<RequirePermission permission="empresas.view"><ProcuradorVincularEmpresas /></RequirePermission>} />
                <Route path="perfis-permissoes" element={<RequirePermission permission="perfis_permissoes.view"><PerfisPermissoes /></RequirePermission>} />
                <Route path="auditoria" element={<RequirePermission permission="auditoria.view"><Auditoria /></RequirePermission>} />
                <Route path="sisi" element={<Sisi />} />
                <Route path="ia" element={<Navigate to="/app/sisi" replace />} />
                <Route path="automacoes" element={<RequirePermission permission="automacoes.view"><Automacoes /></RequirePermission>} />
                <Route path="api-keys" element={<RequirePermission permission="api_keys.view"><ApiKeys /></RequirePermission>} />
                <Route path="configuracoes" element={<RequirePermission permission="configuracoes.view"><Configuracoes /></RequirePermission>} />
                <Route path="meu-plano" element={<RequirePermission permission="configuracoes.view"><MeuPlano /></RequirePermission>} />

                {/* Módulos v2 — Coming Soon */}
                <Route path="clientes" element={<Clientes />} />
                <Route path="painel-360" element={<RequirePermission permission="diagnostico.view"><Painel360 /></RequirePermission>} />

                {/* SIMPLER AI · BI · Diagnóstico · Relatórios · Agenda */}
                <Route path="diagnostico" element={<DiagnosticoGeral />} />
                <Route path="bi" element={<SimplerBI />} />
                <Route path="bi/ausencias" element={<SimplerBI />} />
                <Route path="bi/diagnosticos" element={<SimplerBI />} />
                <Route path="health-score" element={<RequirePermission permission="diagnostico.view"><HealthScore /></RequirePermission>} />
                <Route path="bi/indicadores" element={<SimplerBI />} />
                <Route path="relatorios" element={<Relatorios />} />

                {/* Módulos fiscais consumindo Integration Engine */}
                <Route path="certidoes" element={<Certidoes />} />
                <Route path="parcelamentos" element={<Parcelamentos />} />
                <Route
                  path="parcelamentos/:parcelamentoId"
                  element={<ParcelamentoDetalhe />}
                />
                <Route path="agenda" element={<Agenda />} />
                <Route path="obrigacoes" element={<Obrigacoes />} />
                <Route path="simples-nacional" element={<SimplesNacional />} />
                <Route
                  path="simples-nacional/apuracao"
                  element={<SimplesNacionalApuracao />}
                />
                <Route path="simples-nacional/fator-r" element={<FactorR />} />
                <Route path="dashboard-federal/defis" element={<Defis />} />
                <Route path="simples-nacional/das" element={<GestaoDAS />} />
                <Route path="dctfweb" element={<DCTFWeb />} />

                {/* Platform Owner-only */}
                <Route path="plataforma-saude" element={<RequirePermission permission="plataforma_saude.view"><PlataformaSaude /></RequirePermission>} />
                <Route path="plataforma-inicio" element={<PlataformaInicio />} />
                <Route path="plataforma-tenants" element={<RequirePermission permission="plataforma_saude.view"><PlataformaTenants /></RequirePermission>} />
                <Route path="plataforma-ativacao" element={<PlataformaAtivacao />} /> {/* PP10 */}
                <Route
                  path="plataforma-atendimento"
                  element={
                    <RequirePlatformOwner>
                      <PlataformaAtendimento />
                    </RequirePlatformOwner>
                  }
                />
                <Route path="plataforma-resultados" element={<RequirePermission permission="plataforma_saude.view"><PlataformaResultados /></RequirePermission>} />
                <Route path="plataforma-financeiro" element={<RequirePermission permission="plataforma_saude.view"><PlataformaFinanceiro /></RequirePermission>} />
                <Route path="plataforma-serpro" element={<RequirePermission permission="plataforma_saude.view"><PlataformaSerpro /></RequirePermission>} />
                <Route
                  path="plataforma/consumo-serpro"
                  element={
                    <RequirePlatformOwner>
                      <PlataformaSerproUsage />
                    </RequirePlatformOwner>
                  }
                />

                {/* Outros módulos v2 ainda coming-soon */}
                <Route path="reforma-tributaria" element={<ComingSoon slug="reforma-tributaria" />} />
                <Route path="atendimento" element={<Atendimento />} />
              </Route>

              <Route path="*" element={<NotFound />} />
</Routes>
            </Suspense>
            <Toaster theme="dark" position="top-right" richColors closeButton />
          </BrowserRouter>
        </PermissionsProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
